import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AppBar, Box, Toolbar } from '@mui/material';

import { useDirection } from '@/hooks/useDirection';
import { ROUTER_PATHS } from '@/root/linker';
import { borders } from '@/theme/constants';

import Logo from './assets/logo.svg?react';
import ProfileMenu from './components/ProfileMenu';

const Header = () => {
  const { t } = useTranslation('common');
  const { applyDirectionalStyles } = useDirection();

  return (
    <AppBar position="fixed" elevation={0} sx={{ borderBottom: borders.default, borderColor: 'grey.400' }}>
      <Toolbar
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          '.MuiAppBar-root &': { ...applyDirectionalStyles(3, 1.5, 'pl', 'pr') }
        }}
      >
        <Box component={Link} title={t('header.logo')} to={ROUTER_PATHS.HOME} sx={{ mt: 0.5 }}>
          <Logo />
        </Box>
        <ProfileMenu />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
